module.exports = __webpack_public_path__ + "static/media/iconM4.41dba2d6.svg";